import React, { useEffect, useState } from "react";
import Typography from "@material-ui/core/Typography";
import cloudStore from "../store/CloudStore";
import { useParams } from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import { CircularProgress, TablePagination } from "@material-ui/core";
import { _get } from "../Api";
import { toast } from "react-toastify";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import withIntl from "../utils/withIntl";

const rowsPerPage = 50;

function InhouseGuestRegistration(props) {
  const [spMerchant, setSpMerchant] = React.useState(null);
  const spMerchantId = Number.parseInt(useParams().spMerchantId);
  const [guestRegistrations, setGuestRegistrations] = React.useState(null);
  const [page, setPage] = useState(0);

  useEffect(() => {
    if (spMerchant && !guestRegistrations) {
      _get("/nova/v2/sp_merchants/" + spMerchantId + "/guest_registrations")
        .then((res) => {
          setGuestRegistrations(res.data);
        })
        .catch((e) => {
          toast.error("Something went wrong.", {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          console.log(e);
          return Promise.reject();
        });
    }
  }, [spMerchant]);

  if (spMerchantId !== spMerchant?.id) {
    setSpMerchant(cloudStore.merchant.sp_merchants.find((spMerchant) => spMerchant.id === spMerchantId));
    return null;
  }

  return (
    <div style={{ width: "60%", float: "left" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Typography variant="h4">
            {props.intl.formatMessage({ id: "guest_registration" })}: {cloudStore.merchant.name}
          </Typography>
        </div>
      </div>
      <Divider style={{ marginBottom: "20px" }} />
      {guestRegistrations == null ? (
        <CircularProgress />
      ) : (
        <>
          <TableContainer>
            <Table style={{ width: "auto" }} size="small">
              <TableHead>
                <TableRow>
                  {guestRegistrations[0]?.contact_details.map((customField) => (
                    <TableCell style={{ padding: 5 }}>{customField.label}</TableCell>
                  ))}
                  <TableCell style={{ padding: 5 }}>Date</TableCell>
                  <TableCell style={{ padding: 5 }}>Table</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {guestRegistrations
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((guestRegistration) => {
                    return (
                      <TableRow key={guestRegistration.id}>
                        {guestRegistration.contact_details.map((customField) => (
                          <TableCell style={{ padding: 5 }}>
                            <Typography>{customField.value}</Typography>
                          </TableCell>
                        ))}
                        <TableCell style={{ padding: 5 }}>
                          <Typography>{new Date(guestRegistration.created_at).toLocaleString()}</Typography>
                        </TableCell>
                        <TableCell style={{ padding: 5 }}>
                          <Typography>{guestRegistration.table_id}</Typography>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={guestRegistrations.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={(event, newPage) => {
              setPage(newPage);
            }}
            labelRowsPerPage=""
            rowsPerPageOptions={[rowsPerPage]}
          />
        </>
      )}
    </div>
  );
}

export default withIntl(InhouseGuestRegistration);
